import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useLocation, Link } from 'react-router-dom';
import Twemoji from "react-twemoji";

import ProjectSpecs from "../components/ProjectSpecs";
import RandomText from "../effects/RandomText";
import ImageComponent from "../components/ImageComponent";
import VideoComponent from "../components/VideoComponent";
import BulletListComponent from "../components/BulletListComponent";
import SourceCodeComponent from "../components/SourceCodeComponent";
import Tooltip from "../components/Tooltip";
import Loading from "./Loading";

export default function ProjectItem() {
    const location = useLocation();

    const { id } = useParams();

    const [product, setProduct] = useState(null);
    const [data, setData] = useState([]);
    const [url, setUrl] = useState("");
    const [name, setName] = useState("");
    const [categories, setCategories] = useState([]);
    const [thumbnail, setThumbnail] = useState("");
    const [status, setStatus] = useState("");

    const [loading, setLoading] = useState(true);
    // Pagination logic (from BlogItem)
    const [hasMore, setHasMore] = useState(false);
    const [nextCursor, setNextCursor] = useState(null);

    const fetchProduct = async ( id ) => {
        try {
        const response = await fetch(`https://imajin.dev/api/retrieve-a-page?id=${id}`, {
            method: "GET",
            headers: {
            "Content-Type": "application/json",
            },
        });
    
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
    
        const result = await response.json();
        // console.log(result);

        setStatus(result.properties?.Status?.select?.name || "");
        
        { result.properties?.URL ?
            setUrl(result.properties?.URL?.rich_text?.[0]?.plain_text) : setUrl("");
        }

        setProduct(result);
        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    };

    const fetchData = async () => {
        try {
            const response = await fetch(`https://imajin.dev/api/retrieve-block-children?id=${id}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const responseData = await response.json(); 

            // console.log(responseData);
            setData(responseData.results);
            setHasMore(responseData.has_more);
            setNextCursor(responseData.next_cursor);
        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    };

    // Pagination fetch (from BlogItem)
    const fetchDataPagination = async (startCursor = null) => {
        try {
            let url = `https://imajin.dev/api/retrieve-block-children?id=${id}`;
            if (startCursor) {
                url += `&start_cursor=${startCursor}`;
            }
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const responseData = await response.json();
            setData((prevData) => [...prevData, ...responseData.results]);
            setHasMore(responseData.has_more);
            setNextCursor(responseData.next_cursor);
        } catch (error) {
            // Error fetching additional data
        }
    };

    // Handler for Load More
    const handleLoadMore = () => {
        if (nextCursor) {
            fetchDataPagination(nextCursor);
        }
    };

    useEffect(() => {
        const loadPage = async () => {
            setLoading(true);
            try {
                await Promise.all([
                    fetchProduct(id),
                    fetchData(),
                ]);
            } finally {
                setLoading(false);
            }
        };

        loadPage();
    }, [id]);

    return(
        <Twemoji options = { { className: 'twemoji' } } key = { location.pathname }>
        { loading ? <Loading url = "https://yujinyi.notion.site/Works-343afaf7b6848017a6fafb9ce5af1ff0?source=copy_link"/> : 
        <div className = "page">
            {/* <h2 style = { { lineHeight : "120%" } }>{ product.properties?.Name?.title[0].plain_text }</h2> */}

            <h1 className = "heading" style = { { fontSize : "64px", color : "var(--black88)", lineHeight : "100%" }}>{ product.properties?.Name?.title[0].plain_text }</h1>

            <br/>
            <img src = { product.icon?.file?.url }/> 
            <br/><br/>

            { status === "Live" && <ProjectSpecs data = { product }/> }

            <br/><br/>
            
            {/* PAGE CONTENTS */}
            { data.map( ( item ) => (
                <div key = { item.id }>
                    { item.type === "paragraph" && (
                        <div>
                            {Array.isArray(item[item.type]?.rich_text) && item[item.type].rich_text.length === 0 ? (
                                <div className="br"/>
                            ) : item[item.type]?.rich_text?.[0]?.href ? (
                                <a className = "animated-underline" target = "_blank" href = { item[item.type]?.rich_text?.[0]?.href }>
                                    { item[item.type]?.rich_text?.[0]?.href }
                                </a>
                            ) : (
                                <p
                                    style = {{
                                        color: item[item.type]?.color === "black"
                                            ? "black"
                                            : item[item.type]?.color === "blue"
                                            ? "blue"
                                            : "inherit", // Default color,
                                        padding : "4px 0px"
                                    }}
                                >
                                    { item[item.type]?.rich_text?.[0]?.plain_text }
                                </p>
                            )}
                        </div>
                    )}

                  { item.type === "heading_1" && (
                    <h1 className="heading">{ item[item.type]?.rich_text[0]?.plain_text }</h1>
                  )}

                  { item.type === "heading_2" && (
                    <h2 className="heading">{ item[item.type]?.rich_text[0]?.plain_text }</h2>
                  )}

                  { item.type === "heading_3" && (
                    <h3 className="heading">{ item[item.type]?.rich_text[0]?.plain_text }</h3>
                  )}

                  { item.type === "divider" && <div className = "hr" /> }

                  { item.type === "bulleted_list_item" && (
                    <BulletListComponent item = { item } />
                  )}

                    {item.type === "image" && (
                        <ImageComponent data={item[item.type]} />
                    )}



{/* INTERFACE HIGHLIGHT - VIDEO & IMAGE */}
                    {item.type === "video" && (() => {
                        const videoData = item[item.type];
                        const caption = videoData?.caption?.[0]?.plain_text || "";

                        // IF EXTERNAL YOUTUBE VIDEO
                        if (videoData?.type === "external" && videoData?.external?.url) {
                            // Extract YouTube video ID if possible
                            const url = videoData.external.url;
                            let embedUrl = url;
                            // Try to convert to embed format if it's a YouTube link
                            const youtubeMatch = url.match(/(?:https?:\/\/(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/))([\w-]{11})/);
                            if (youtubeMatch) {
                                embedUrl = `https://www.youtube.com/embed/${youtubeMatch[1]}`;
                            }
                            return (
                                <div style={{ width: "100%", margin: "24px 0" }}>
                                    <div style={{ width: "100%", aspectRatio: "16 / 9" }}>
                                        <iframe
                                        src={embedUrl}
                                        title="YouTube video player"
                                        style={{ width: "100%", height: "100%", border: "0" }}
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowFullScreen
                                        />
                                    </div>
                                </div>
                            );
                        }

                        if (caption.startsWith("[Interface Highlight]")) {
                            return (
                                <div>
                                    hello
                                </div>
                            );
                        }
                        
                        if (caption.startsWith("[Mobile]")) {
                            // console.log(videoData);
                            return (
                                <div style = { { display : "flex", width : "100%", alignItems : "center"} }>
                                    <video
                                        style={{
                                        maxWidth: "280px",
                                        // aspectRatio: "9 / 16",
                                        margin: "0 auto",
                                        borderRadius: "40px",
                                        border : "8px solid var(--bg4)",
                                        overflow: "hidden",
                                        }}
                                        controls
                                        autoPlay
                                        muted
                                        loop
                                        playsInline
                                    >
                                        <source src={videoData?.file?.url} type="video/mp4" />
                                    </video>
                                </div>
                                
                            );
                        }
                        
                        if (caption.startsWith("[Web]")) {
                            return (
                                <div style = { { position : "relative", display : "flex", width : "100%",
                                    background : "var(--black8)",
                                    border : "1px solid var(--bg4)",
                                    paddingLeft : "0px",
                                    paddingTop : "8px",
                                    marginTop : "20px",
                                    marginBottom : "20px",
                                    borderRadius : "4px 4px 0px 0px",
                                } }>
                                    <div style = { { position : "absolute", top : "2px", left : "4px", display : "flex", flexDirection : "row", gap : "2px" }}>
                                        <span style = { { width : "4px", height : "4px", background : "white", borderRadius: "50%"} } />
                                        <span style = { { width : "4px", height : "4px", background : "white", borderRadius: "50%"} } />
                                        <span style = { { width : "4px", height : "4px", background : "white", borderRadius: "50%"} } />
                                    </div>
                                    <video
                                        style = { { 
                                            width : "100%",
                                        } } 
                                        controls
                                        autoPlay
                                        muted
                                        loop
                                        playsInline
                                    >
                                        <source src={videoData?.file?.url} type="video/mp4" />
                                    </video>
                                </div>
                            );
                        } else {
                            return <VideoComponent data={videoData} width="100" />;
                        }
                    })()}


                    
                    {/* { item.type === "video"  && item[item.type]?.caption?.[0]?.plain_text?.startsWith("[Interface Highlight]") && (
                        <InterfaceHighlight/>
                    )}; */}

                    { item.type === "code" && (
                        <SourceCodeComponent data = {item[item.type]}/>
                    )}
                </div>
            ))}

                        {/* <Comment id = { id } blog = { name }/> */}

                        {/* Pagination: Load More */}
                        { hasMore && (
                                <div>
                                    <p className = "meta2">There are more.</p>
                                    <button className = "moreButton" onClick = { handleLoadMore } style = { { width : "100%", height : "48px" } }>Load More</button>
                                </div>
                        )}
        </div>
}
        </Twemoji>
    )
}